export default __webpack_public_path__ + "static/media/LEVEL13.81d8aec6.png";